import { Fragment } from "react";
import { ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";
import type { TaskBreadcrumbItem } from "@/lib/task-detail-navigation";

interface Props {
  items: TaskBreadcrumbItem[];
  activeTaskId: string;
  onNavigate: (taskId: string) => void;
  className?: string;
}

export function TaskDetailBreadcrumb({
  items,
  activeTaskId,
  onNavigate,
  className,
}: Props) {
  if (items.length === 0) return null;

  return (
    <nav
      className={cn("flex flex-wrap items-center gap-1 text-xs text-muted-foreground", className)}
      aria-label="Caminho da tarefa"
    >
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        const isActiveTask = item.kind === "task" && item.id === activeTaskId;

        return (
          <Fragment key={`${item.kind}-${item.id}`}>
            {index > 0 && (
              <ChevronRight className="h-3 w-3 shrink-0 opacity-50" aria-hidden />
            )}
            {item.kind === "task" && !isLast ? (
              <button
                type="button"
                onClick={() => onNavigate(item.id)}
                className="max-w-[180px] truncate hover:text-foreground hover:underline underline-offset-2"
                title={item.label}
              >
                {item.label}
              </button>
            ) : (
              <span
                className={cn(
                  "max-w-[220px] truncate",
                  isActiveTask && "font-medium text-foreground",
                )}
                title={item.label}
              >
                {item.label}
              </span>
            )}
          </Fragment>
        );
      })}
    </nav>
  );
}
